<template>
  <div class="course-details">
    <h6 class="text-primary">Course Details</h6>
    <CRow>
      <CCol lg="6">
        <CRow class="mb-3">
          <label class="col-lg-12 col-md-12 required"
            >Course Title (Full name)</label
          >
          <div class="col-lg-12 col-md-12 col-sm-12">
            <TextInput
              name="course_title"
              :value="courseDetail.course_title"
              @input="handleInput"
            />
          </div>
        </CRow>
      </CCol>
      <CCol lg="6" v-if="isUG_PG">
        <CRow class="mb-3">
          <label class="col-lg-12 col-md-12"
            >Healthcare Sector/Department</label
          >
          <div class="col-lg-12 col-md-12 col-sm-12">
            <Select
              name="org_dept_id"
              :value="courseDetail.org_dept_id"
              :options="
                options && options['orgDepartment']
                  ? options['orgDepartment']
                  : []
              "
              :multiple="false"
              :clearable="false"
              @input="handleChangeSelect"
            />
          </div>
        </CRow>
      </CCol>
      <CCol lg="6" v-else>
        <CRow class="mb-3">
          <label class="col-lg-12 col-md-12"
            >Healthcare Sector/Department</label
          >
          <div class="col-lg-12 col-md-12 col-sm-12">
            <Select
              name="healthcare_sector"
              :value="courseDetail.healthcare_sector"
              :options="
                options && options['courseHealthcareSector']
                  ? options['courseHealthcareSector']
                  : []
              "
              :multiple="false"
              :clearable="false"
              @input="handleChangeSelect"
            />
          </div>
        </CRow>
      </CCol>
      <CCol lg="6">
        <CRow class="mb-3">
          <label class="col-lg-12 col-md-12">Description</label>
          <div class="col-lg-12 col-md-12 col-sm-12">
            <TextAreaInput
              name="course_synopsis"
              :value="courseDetail.course_synopsis"
              @input="handleInput"
              :rows="3"
            />
          </div>
        </CRow>
      </CCol>
      <CCol lg="6">
        <CRow class="mb-3">
          <label class="col-lg-12 col-md-12">Course Reference</label>
          <div class="col-lg-12 col-md-12 col-sm-12">
            <TextInput
              name="course_ref"
              :value="courseDetail.course_ref"
              @input="handleInput"
            />
          </div>
        </CRow>
      </CCol>
      <CCol lg="6">
        <CRow class="mb-3">
          <label class="col-lg-12 col-md-12 required">Course Type</label>
          <div class="col-lg-12 col-md-12 col-sm-12">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <Select
                name="course_test_type_id"
                :value="courseDetail.course_test_type_id"
                :options="
                  options && options['course_type']
                    ? options['course_type']
                    : []
                "
                :multiple="false"
                :clearable="false"
                @input="handleChangeSelect"
                :error="errors[0]"
              />
            </ValidationProvider>
          </div>
        </CRow>
      </CCol>
      <!-- <CCol lg="4">
        <CRow class="mb-3">
          <label class="col-lg-12 col-md-12 required">Student Type</label>
          <div class="col-lg-12 col-md-12 col-sm-12">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <Select
                name="candidate_type_ids"
                :value="courseDetail.candidate_type_ids"
                :options="
                  options && options['candidateType']
                    ? options['candidateType']
                    : []
                "
                :multiple="true"
                :clearable="false"
                @input="handleChangeMultiSelect"
                :error="errors[0]"
                :limit="1"
              />
            </ValidationProvider>
          </div>
        </CRow>
      </CCol> -->
      <CCol lg="6">
        <CRow class="mb-3">
          <label class="col-lg-12 col-md-12 required">Course Level</label>
          <div class="col-lg-12 col-md-12 col-sm-12">
            <ValidationProvider
              ref="courseLevel"
              rules="required"
              v-slot="{ errors }"
            >
              <Select
                name="isced_level_id"
                :value="courseDetail.isced_level_id"
                :options="
                  options && options['courseLevel']
                    ? options['courseLevel']
                    : []
                "
                :multiple="false"
                :clearable="false"
                @input="handleChangeSelect"
                :error="errors[0]"
              />
            </ValidationProvider>
          </div>
        </CRow>
      </CCol>
      <!-- <CCol md="4">
        <CRow class="mb-3">
          <label class="col-lg-12 col-md-12">CPD Points</label>
          <div class="col-lg-12 col-md-12 col-sm-12">
            <Select
              name="cpd_points"
              :value="courseDetail.cpd_points"
              :options="
                options && options['cpdPoints'] ? options['cpdPoints'] : []
              "
              :multiple="false"
              :clearable="true"
              @input="handleChangeSelect"
            />
          </div>
        </CRow>
      </CCol> -->
      <CCol md="6">
        <CRow class="mb-3">
          <label class="col-lg-12 col-md-12">Start Date</label>
          <div class="col-lg-12 col-md-12 col-sm-12">
            <DatePicker
              name="start_date"
              :value="courseDetail.start_date"
              @input="handleDatePicker"
              format="DD-MM-YYYY"
            />
          </div>
        </CRow>
      </CCol>
      <CCol md="6">
        <CRow class="mb-3">
          <label class="col-lg-12 col-md-12">End Date</label>
          <div class="col-lg-12 col-md-12 col-sm-12">
            <DatePicker
              name="end_date"
              :value="courseDetail.end_date"
              @input="handleDatePicker"
              format="DD-MM-YYYY"
            />
          </div>
        </CRow>
      </CCol>
      <!-- <CCol md="4">
        <CRow class="mb-3">
          <label class="col-lg-12 col-md-12">Duration Access(Months)</label>
          <div class="col-lg-12 col-md-12 col-sm-12">
            <ValidationProvider rules="numeric" v-slot="{ errors }">
              <TextInput
                name="duration_months"
                :value="courseDetail.duration_months"
                @input="handleInput"
                :error="errors[0]"
              />
            </ValidationProvider>
          </div>
        </CRow>
      </CCol> -->
      <!-- <CCol md="4">
        <CRow class="mb-3">
          <label class="col-lg-12 col-md-12 required">Country</label>
          <div class="col-lg-12 col-md-12 col-sm-12">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <Select
                name="country_id"
                :value="courseDetail.country_id"
                :options="
                  options && options['locations'] ? options['locations'] : []
                "
                :error="errors[0]"
                :clearable="false"
                @input="handleChangeSelect"
              />
            </ValidationProvider>
          </div>
        </CRow>
      </CCol> -->
      <CCol md="6">
        <CRow class="mb-3">
          <label class="col-lg-12 col-md-12">Qualification</label>
          <div class="col-lg-12 col-md-12 col-sm-12">
            <Select
              name="qualification_id"
              :value="courseDetail.qualification_id"
              :options="
                options && options['qualifications']
                  ? options['qualifications']
                  : []
              "
              @input="handleChangeSelect"
            />
          </div>
        </CRow>
      </CCol>
      <CCol lg="6" v-if="isUG && isShowTrainArea">
        <CRow class="mb-3">
          <label class="col-lg-12 col-md-12 required">Training Area</label>
          <div class="col-lg-12 col-md-12 col-sm-12">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <Select
                name="speciality_id"
                :value="courseDetail.speciality_id"
                :options="
                  options && options['courseSpeciality']
                    ? options['courseSpeciality']
                    : []
                "
                :multiple="false"
                :clearable="false"
                @input="handleChangeSelect"
                :error="errors[0]"
              />
            </ValidationProvider>
          </div>
        </CRow>
      </CCol>
      <CCol lg="6">
        <CRow class="mb-3">
          <label class="col-lg-12 col-md-12">Study Mode</label>
          <div class="col-lg-12 col-md-12 col-sm-12">
            <Select
              name="study_mode"
              :value="courseDetail.study_mode"
              :options="
                options && options['studyMode'] ? options['studyMode'] : []
              "
              :multiple="true"
              :clearable="true"
              @input="handleChangeMultiSelect"
            />
          </div>
        </CRow>
      </CCol>
      <CCol lg="6">
        <CRow class="mb-3">
          <label class="col-lg-12 col-md-12">Delivery Language</label>
          <div class="col-lg-12 col-md-12 col-sm-12">
            <Select
              name="language_id"
              :value="courseDetail.language_id"
              :options="
                options && options['languages'] ? options['languages'] : []
              "
              :multiple="false"
              :clearable="false"
              @input="handleChangeSelect"
            />
          </div>
        </CRow>
      </CCol>
      <CCol lg="6" v-if="isUG_PG">
        <CRow class="mb-3">
          <label class="col-lg-12 col-md-12">ISCED</label>
          <div class="col-lg-12 col-md-12 col-sm-12">
            <Select
              name="isced_level_id"
              :value="courseDetail.isced_level_id"
              :options="options && options['ISCED'] ? options['ISCED'] : []"
              :multiple="false"
              :clearable="false"
              @input="handleChangeSelect"
            />
          </div>
        </CRow>
      </CCol>
    </CRow>
    <CRow>
      <CCol md="4">
        <input
          type="checkbox"
          :name="`semesters_terms`"
          :value="courseDetail.semesters_terms"
          :checked="courseDetail.semesters_terms || false"
          @click="handleCheck('semesters_terms', $event.target.checked)"
        />
        <label class="mx-2">Semesters/Terms</label>
      </CCol>
      <CCol md="4">
        <input
          type="checkbox"
          :name="`modules`"
          :value="courseDetail.modules"
          :checked="courseDetail.modules || false"
          @click="handleCheck('modules', $event.target.checked)"
        />
        <label class="mx-2">Course Modules</label>
      </CCol>
      <CCol md="4">
        <input
          type="checkbox"
          :name="`options`"
          :value="courseDetail.options"
          :checked="courseDetail.options || false"
          @click="handleCheck('options', $event.target.checked)"
        />
        <label class="mx-2">Course Options</label>
      </CCol>
    </CRow>
  </div>
</template>
<script>
import Vue from "vue";
import m from "moment";
import courseMixin from "@/containers/Course/AddCourse/courseMixin.js";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "CourseDetail",
  mixins: [courseMixin],
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["getCourseQualifications", "getCourseLevels"]),
    options() {
      return {
        course_type: this.courseTypes,
        languages: this.locationLanguageReOrder,
        courseHealthcareSector: this.courseHealthcareSector,
        orgDepartment: this.getOrgDepartments,
        candidateType: this.customCandidateType,
        // courseLevel: this.isHasCandidateType
        //   ? this.getCourseQualClassification
        //   : [],
        courseLevel: this.getCourseLevels
          .filter(v => Number(v.level) >= 4)
          .sort((a, b) => Number(b.level) - Number(a.level))
          .map(v => ({
            label: v.description, 
            code: v.isced_id    
        })),
        locations: this.locationCountryInfo,
        qualifications: this.qualificationByCountryAndCandidateType,
        cpdPoints: this.CPDPoints,
        studyMode: this.trainingTypes,
        courseSpeciality: this.customSpeciality,
        ISCED: this.getISCEDLevels,
      };
    },
    isAHP(){
      return this.payload?.courseDetail?.candidate_type_ids?.includes(3)
    },
    customSpeciality(){
      return this.getCourseSpeciality.map(v=> ({
        code: v.code,
        label: this.isAHP? v.alt_speciality_name : v.label
      }))
    },
    isHasCandidateType() {
      return this.courseDetail?.candidate_type_ids?.length || false;
    },
    CPDPoints() {
      const points = Array.from({ length: 250 }, (_, i) => i + 1).map((v) => ({
        code: v,
        label: v,
      }));
      return [{ code: null, label: "N/A" }, ...points];
    },
    isUG_PG() {
      return (
        [2, 3].includes(this.payload?.courseDetail?.course_test_type_id) ||
        false
      );
    },
    isUG() {
      return this.payload?.courseDetail?.course_test_type_id === 2 || false;
    },
    isShowTrainArea() {
      return (
        [2, 3].some((v) =>
          this.payload?.courseDetail?.candidate_type_ids?.includes(v)
        ) || false
      );
    },
  },
  methods: {
    ...mapActions([
      "fetchCourseQualification",
      "fetchQualificationByQuery",
      "fetchQualificationClassification",
      "fetchCourseSpeciality",
    ]),
    handleChangeMultiSelect(name, value) {
      const val = value.map((v) => {
        return v.id || v.code || v;
      });
      Vue.set(this.courseDetail, name, value);
      this.payload.courseDetail = {
        ...this.payload.courseDetail,
        [name]: value ? val : null,
      };
      if (name === "candidate_type_ids") {
        this.handleChangeSelect("isced_level_id", null);
        this.$nextTick(() => {
          this.$refs.courseLevel.errors.clear;
          this.$refs.courseLevel.reset();
        });
        if (val?.length)
          this.fetchQualificationClassification({
            candidate_type_id__in: val,
            sort_level__lte: 100,
          });
        this.fetchSpeciality(val);
        this.fetchQualification();
      }
      this.updateParentData();
    },
    handleChangeSelect(name, value) {
      Vue.set(this.courseDetail, name, value);
      const val = value ? value.id || value.code  : null;
      this.payload.courseDetail = {
        ...this.payload.courseDetail,
        [name]: val,
      };

      if (name === "course_test_type_id") {
        if (this.isUG_PG) this.handleChangeSelect("healthcare_sector", null);
        else {
          this.handleChangeSelect("org_dept_id", null);
          this.handleChangeSelect("isced_level_id", null);
        }
      }
      if (["isced_level_id"].includes(name)) {
        this.fetchQualification();
      }
      this.updateParentData();
    },
    fetchSpeciality(candidate_type_ids) {
      const candidate_type_id = candidate_type_ids?.[0];
      this.handleChangeSelect("speciality_id", null);
      if ([1, 4].includes(candidate_type_id)) {
        const speciality_id = {
          1: {
            code: 403,
            label: "In Training",
          },
          4: {
            code: 137,
            label: "In Training",
          },
        };
        this.handleChangeSelect(
          "speciality_id",
          speciality_id[candidate_type_id]
        );
      } else {
        const is_training = candidate_type_id === 2;
        let payload = { candidate_type_id, is_training };
        this.fetchCourseSpeciality(payload);
      }
    },
    handleCheck(name, value) {
      Vue.set(this.courseDetail, name, value);
      this.payload.courseDetail[name] = value;
      this.updateParentData();
    },
    fetchQualification() {
      const { candidate_type_ids, isced_level_id } = this.payload.courseDetail;
      if (candidate_type_ids && isced_level_id) {
        const country_ids = this.organisationCountryIds?.join();
        const data = {
          candidate_type_id__in: candidate_type_ids,
          qualification_classification_id: isced_level_id,
          country_id__in: `${country_ids},null`,
        };
        this.fetchQualificationByQuery(data);
      }
    },
    handleInput(name, value) {
      Vue.set(this.courseDetail, name, value);
      Vue.set(this.payload.courseDetail, name, value);
      this.updateParentData();
    },
    handleDatePicker(name, value) {
      Vue.set(this.courseDetail, name, value);
      Vue.set(
        this.payload.courseDetail,
        name,
        value ? m(value).format("YYYY-MM-DD") : null
      );
    },
    updateParentData() {
      const formName = "courseDetail";
      this.$emit("syncData", formName, this.payload[formName]);
    },
  },
  mounted() {
    this.handleChangeSelect("cpd_points", { code: null, label: "N/A" });
  },
};
</script>
